export const DIMENSION_KIND = 'Kind';
export const DIMENSION_TARGET_MARKET = 'TargetMarket';
export const DIMENSION_PACKAGING_TYPE = 'TypePackaging';
